import api from '../api.js';


class AiAgentService {
    // ================== Health ==================
    /** Перевірка стану сервера */
    static async healthCheck() {
        const response = await api.get('/health-check');
        return response.data;
    }

    // ================== Чати ==================
    /** Отримати всі чати */
    static async getAllChats() {
        const response = await api.get('/get-chats');
        return response.data;
    }

    /** Отримати повідомлення чату */
    static async getChatMessages(chatId) {
        const response = await api.get('/get-chat-messages', {
            params: { chat_id: chatId }
        });
        return response.data;
    }

    /** Отримати деталі повідомлення */
    static async getDetailMessage(messageId) {
        const response = await api.get('/get-detail-message', {
            params: { messageId }
        });
        return response.data;
    }

    // ================== Конфіги агентів ==================
    /** Отримати список конфігурацій агентів */
    static async getListOfAgentConfigs() {
        const response = await api.get('/get-agent-configs');
        return response.data;
    }

    /** Створити конфігурацію агента */
    static async createAgentConfig(configData) {
        const response = await api.post('/create-agent-config', configData);
        return response.data;
    }

    /** Оновити конфігурацію агента */
    static async updateAgentConfig(configData) {
        const response = await api.put('/update-agent-config', configData);
        return response.data;
    }

    /** Видалити конфігурацію агента */
    static async deleteAgentConfig(configId) {
        const response = await api.delete(`/delete-agent-config/${configId}`);
        return response.data;
    }

    // ================== Дані користувача ==================
    /** Встановити роль для користувача */
    static async setCustomerRole(customerId, roleId) {
        const response = await api.put('/set-customer-role', { customerId, roleId });
        return response.data;
    }

    /** Отримати роль користувача */
    static async getCustomerRole() {
        const response = await api.get('/get-customer-role');
        return response.data;
    }

    /** Отримати всіх користувачів */
    static async getAllCustomers({ customerName = '', limit = 10, serverUrl = '', skip = 0 }) {
        const response = await api.post('/get-all-customers', {
            customerName,
            limit,
            serverUrl,
            skip
        });
        return response.data;
    }

    // ================== Документація ==================
    /** Згенерувати документацію */
    static async regenerateDocumentation(body) {
        const response = await api.post('/regenerate-documentation', body);
        return response.data;
    }

    /** Перестворити документацію для всіх мов (RU, UK, EN) */
    static async regenerateAllDocumentation(body) {
        const response = await api.post('/regenerate-all-documentation', body);
        return response.data;
    }

    // ================== Промпти ==================
    /** 
     * Отримати промпт з версіями
     * @param {Object} params
     * @param {number} [params.prompt_id] - ID промпту
     * @param {string} [params.prompt_identifier] - Унікальний ідентифікатор промпту
     * @param {string} [params.prompt_name] - Назва промпту
     * @param {number} [params.versions_page=1] - Номер сторінки версій
     * @param {number} [params.versions_page_size=10] - Кількість версій на сторінку
     */
    static async getPromptWithVersions(params) {
        const response = await api.get('/get-prompt-with-versions', { params });
        return response.data;
    }

    /** 
     * Створити нову версію промпта
     * @param {Object} data
     * @param {number} data.prompt_id - ID промпту
     * @param {string} data.prompt_content - Контент промпту
     * @param {string} data.author - Автор версії
     * @param {string} [data.description] - Опис змін
     * @param {string} [data.tags] - Теги через кому
     * @param {string} [data.parent_commit_hash] - Хеш батьківського коміту
     */
    static async createPromptVersion(data) {
        const response = await api.post('/create-version', data);
        return response.data;
    }

    /** Отримати список авторів */
    static async getAuthors() {
        const response = await api.get('/get-authors');
        return response.data;
    }

    // ================== Векторні нотатки ==================
    /** Створити векторну нотатку */
    static async createVectorNote(data) {
        const response = await api.post('/create-vector-note', data);
        return response.data;
    }

    // ================== Стрімінг ==================
    /** 
     * Згенерувати нотатку через стрімінг
     * @param {Object} data
     * @param {string} data.user_question - Питання користувача
     * @param {string} data.ai_response - Відповідь AI
     * @param {string} data.corrections - Текст з правками
     * @returns {Promise<ReadableStream>} Стрім з подіями
     */
    static async generateNoteStream(data) {
        const baseURL = api.defaults.baseURL || '';
        const token = sessionStorage.getItem('accessToken');
        
        const response = await fetch(`${baseURL}/generate-note-stream`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }

        return response;
    }

    /** 
     * Зупинити стрімінг сесію
     * @param {string} sessionId - ID сесії для зупинки
     */
    static async stopStream(sessionId) {
        const response = await api.post(`/ask-stream-stop/${sessionId}`);
        return response.data;
    }
}

export default AiAgentService;